document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('[data-syra-related]');
  if (!section) return;

  var track = section.querySelector('[data-syra-related-track]');
  var config = section.querySelector('[data-syra-related-config]');
  var productId = config.getAttribute('data-product-id');
  var moneyFormat = config.getAttribute('data-money-format') || '€{{amount}}';
  var fallbackData = [];

  try {
    fallbackData = JSON.parse(section.querySelector('[data-syra-related-fallback]').textContent);
  } catch (e) {
    fallbackData = [];
  }

  function formatMoney(cents) {
    var whole = Math.round(cents / 100);
    return moneyFormat.replace(/\{\{\s*amount[a-zA-Z_]*\s*\}\}/g, whole);
  }

  function buildCard(p) {
    var img1 = p.featured_image || '';
    var img2 = p.image_2 || '';
    var priceDisplay = typeof p.price === 'number' && p.price > 1000
      ? formatMoney(p.price)
      : formatMoney(p.price * 100);

    var card = document.createElement('a');
    card.href = p.url;
    card.className = 'syra-related__card';
    card.innerHTML =
      '<div class="syra-related__media">' +
        '<img src="' + img1 + '" alt="" class="syra-related__img syra-related__img--front" loading="lazy">' +
        (img2 ? '<img src="' + img2 + '" alt="" class="syra-related__img syra-related__img--back" loading="lazy">' : '') +
      '</div>' +
      '<div class="syra-related__info">' +
        '<p class="syra-related__name">' + p.title + '</p>' +
        '<p class="syra-related__price">' + priceDisplay + '</p>' +
        (p.vendor ? '<p class="syra-related__mood">' + p.vendor + '</p>' : '') +
      '</div>';
    return card;
  }

  function renderCards(products) {
    track.innerHTML = '';
    products.forEach(function (p) {
      track.appendChild(buildCard(p));
    });
  }

  function dedupeAndFill(primary, fallback, minCount) {
    var seen = {};
    var result = [];

    primary.forEach(function (p) {
      if (!seen[p.id]) {
        seen[p.id] = true;
        result.push(p);
      }
    });

    var i = 0;
    while (result.length < minCount && i < fallback.length) {
      if (!seen[fallback[i].id]) {
        seen[fallback[i].id] = true;
        result.push(fallback[i]);
      }
      i++;
    }

    return result;
  }

  // Shopify's eigen aanbevelingen-API — geeft écht relevante producten terug
  fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
    .then(function (res) { return res.ok ? res.json() : { products: [] }; })
    .then(function (data) {
      var recommended = (data.products || []).map(function (p) {
        return {
          id: p.id,
          title: p.title,
          url: p.url,
          vendor: p.vendor,
          price: p.price,
          featured_image: p.featured_image ? p.featured_image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_800x$1$2') : '',
          image_2: (p.images && p.images[1]) ? p.images[1].replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_800x$1$2') : ''
        };
      });

      var final = dedupeAndFill(recommended, fallbackData, 4);

      if (final.length === 0) {
        section.style.display = 'none';
        return;
      }

      renderCards(final);
    })
    .catch(function () {
      // Als de aanbevelingen-API faalt, val volledig terug op de collectie
      var final = fallbackData.slice(0, 8);
      if (final.length === 0) {
        section.style.display = 'none';
        return;
      }
      renderCards(final);
    });
});
